import { render, staticRenderFns } from "./CompanyManagementDetail.vue?vue&type=template&id=d67c14cc&scoped=true&"
import script from "./CompanyManagementDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyManagementDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67c14cc",
  null
  
)

export default component.exports